import checkIsTourBookingFailed from './checkIsTourBookingFailed';

// Other providers leave bookingStatus empty when nothing was booked; a failed tour carries "Failed".
export const checkIsBookingResponseFailed = (bookingResponse) =>
  checkIsTourBookingFailed(bookingResponse) ||
  (!bookingResponse.bookingStatus && !bookingResponse.bookingReference);

const checkIsTripBookingFailed = (tripConfirmation) => {
  const bookingResponses = tripConfirmation && tripConfirmation.bookingResponses;
  if (!bookingResponses) {
    return false;
  }

  const isFailed = bookingResponses.every(checkIsBookingResponseFailed);
  return isFailed;
};

export default checkIsTripBookingFailed;
